import React from 'react'
import * as PropTypes from 'prop-types'
import {linkedAssets} from '@constants'
import {parseISO, isBefore, startOfDay} from 'date-fns'

const AuditStatus = ({expirationDate, type}) => {
  const parsedDate = expirationDate ? parseISO(expirationDate) : null
  const auditType = linkedAssets.mapping.AUDIT.toUpperCase()

  if (parsedDate && type === auditType && isBefore(parsedDate, startOfDay(new Date()))) {
    return (
      <span style={{minWidth: '80px'}} className="tag is-danger">
        <span className="icon is-small">
          <i className="fa-solid fa-ban" />
        </span>
        <span>Expired</span>
      </span>
    )
  }

  return null
}

AuditStatus.propTypes = {
  type: PropTypes.oneOf(Object.keys(linkedAssets.mapping)),
  expirationDate: PropTypes.string,
}

export default AuditStatus
